export default "/_next/static/media/crowdfunding-campaign-1024x502.f37945c8e8eaf694a426ce2dd496cb7f.png";